import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import PageHeader from "../../components/shared/PageHeader";
import PageMain from "../../containers/shared/PageMain";
import MainContent from "../../containers/shared/MainContent";
import MarketPlaceBar from "../../components/marketplace/MarketPlaceBar";
import apiClient from "../../components/utils/apiClient";
import Loading from "../../components/shared/Loading";
import StoreCard from "../../components/marketplace/StoreCard";
import ProductCard from "../../components/marketplace/ProductCard";
import useCart from "../../components/helpers/cartHook";
import useLocalStorage from "../../components/helpers/localStorageHook";
import moment from "moment";
import Toast from "../../components/shared/Toast";
import ModalContainer from "../../containers/shared/ModalContainer";
import NormalButton from "../../components/shared/NormalButton";

const CartPage = () => {
    const {t,i18n} = useTranslation();
    useDocumentTitle('المتاجر');
    const [userData, setUserData] = useState(null);
    const [toast, setToast] = useState({show: false,type: null, message:'' });

    const {id, storeId, storeProductId} = useParams();

    const [selectedUnit, setSelectedUnit] = useState(null);
    const [stores, setStores] = useState(null);

    const [product, setProduct] = useState(null);

    const [isLoading, setIsLoading] = useState(false);

    const [quantity, setQuantity] = useState(1);

    const navigate = useNavigate();

    const { cart, addToCart, removeFromCart, updateQuantity, clearCart, getCartTotal } = useCart();
    const [localStore, setLocalStore, clareLocalStore] = useLocalStorage('selectedUnit');

    const [cartItems, setCartItems] = useState(null);

    const [orderSent, setOrderSent] = useState(false);

    const [noCreditsModal, setNoCreditsModal] = useState(false);

    const [showUnitLimitExceeded, setShowUnitLimitExceeded] = useState(false);

    const [spendingLimitConfig, setSpendingLimitConfig] = useState(null);
    
    const handleCloseModalLimitExceeded = () => {
        setShowUnitLimitExceeded(false);
    }

    const handleGetUser = (user) => {
        setUserData(user);
    }

    const getNearbyStores = async () => {
        setIsLoading(true);
      try {
        const response = await apiClient.get(`/stores/nearby?longitude=${selectedUnit?.long}&latitude=${selectedUnit?.lat}`);
        if(response?.data) {
          setStores(response?.data);
          setIsLoading(false);
        } else {
            setIsLoading(false);
        }
      } catch(err) {setIsLoading(false);}
    }

    useEffect(()=>{
        if(selectedUnit) {
            getNearbyStores();
            getProduct();
        }
    },[selectedUnit]);

    const handleClickProduct = (id) => {
        navigate(`/ar/marketplace/product/${id}`);
    }

    const getProduct = async () => {
      try {
        const response = await apiClient.get(`/store-products/details?productId=${id}&storeId=${storeId}`);
        if(response?.data) {
          setProduct(response?.data);
        } else {
        }
      } catch(err) {}
    }

    useEffect(()=>{
        if(id) {
            getProduct();
        }
    },[id])


    const checkCart = async () => {
        const response = await apiClient.post(`/store-products/check-cart`,{items:cart});
        if(response?.data) {
            setCartItems(response?.data);
        } else {

        }

    }

    useEffect(()=>{
        if(cart && Array.isArray(cart) && cart?.length > 0) {
            checkCart();
        }
    },[cart])

    useEffect(()=>{
        if(localStore) {
            setSelectedUnit(localStore);
        }
    },[localStore])
    


    const handleClickSubmitRequest = () => {

        if(userData?.business?.credits >= cart.reduce((total, obj) => total + (obj.price*obj.quantity), 0)) {
            if(spendingLimitConfig && (cart.reduce((total, obj) => total + (obj.price*obj.quantity), 0) > spendingLimitConfig?.remainingAmount)) {
                setShowUnitLimitExceeded(true);
            } else {
                handleClickSubmitRequestAction();
            }
        } else {
            setNoCreditsModal(true)
        }
    }

    const handleClickSubmitRequestAction = async () => {
        setShowUnitLimitExceeded(false);
        try {
            const response = await apiClient.post(`/orders`,{paymentMethod: 'wallet', items:cart, location: {"latitude": selectedUnit?.lat,"longitude": selectedUnit?.long}, unitId: selectedUnit?.id });
            if(response?.data) {
                clearCart();
                setOrderSent(response?.data);
            } else {
    
            }
        } catch(err) {
            setToast({show:true,type:'error',message:err?.response?.data?.message})
        }
    }

    const handleCloseModal = () => {
        setNoCreditsModal(false);
    }

    const getSpendingLimitConfig = async () => {
        try {
            const response = await apiClient.get(`/b-units/${selectedUnit?.id}`);
            if(response?.data) {
                setSpendingLimitConfig(response?.data?.spendingLimitConfig);            
            }
        } catch(err) {}
    }

    useEffect(()=>{
        if(selectedUnit?.id) {
            getSpendingLimitConfig();
        }
    },[selectedUnit])


  return (
    <div>
            <PageHeader pageTitle={{title: 'السلة'}} userCallback={handleGetUser} />
            <PageMain>
                <div className="absolute top-0 left-0 w-full h-full bg-grey-50 z-0"></div>
                <MainContent>

                    {orderSent && <div className="bg-grey-50 h-[calc(100vh-135px)] pt-[80px]">
                                            <div className="w-[128px] h-[128px] mx-auto !bg-center !bg-no-repeat" style={{background:"url('/assets/images/success.svg')"}}></div>
                                            <div className="max-w-[600px] rounded-s-[16px] bg-white mt-[60px] mx-auto text-center text-grey-900 pt-[25px]">
                                                <p className="font-[700] text-[30px] mb-[15px]">تهانينا !</p>
                                                <p className="font-[500] text-[24px]">لقد تم إرسال طلبك بنجاح.</p>
                                                <p className="font-[500] text-[16px] py-[20px]">سيقوم فريق عملنا بالتواصل معك في اقرب وقت ممكن لتاكيد الطلب.</p>
                                                <p className="font-[500] text-[16px] pb-[15px]">اذا اردت مراجعة طلباتك من فضلك توجه الى الطلبات.</p>
                                                {/* <div className="flex flex-nowrap h-[40px] leading-[40px] bg-grey-200 text-grey-600 text-[14px] font-[500] border-b-[1px] border-b-grey-100 px-[15px]">
                                                    <div className="w-[50%] text-start">توقيت البدء لاول زيارة</div>
                                                    <div className="w-[50%] text-end">{moment().format('DD MMM YYYY')}</div>
                                                </div> */}
                                                <div className="flex flex-nowrap h-[40px] leading-[40px] bg-grey-200 text-grey-600 text-[14px] font-[500] px-[15px]">
                                                    <div className="w-[50%] text-start">إجماليي الطلب</div>
                                                    <div className="w-[50%] text-end">{orderSent?.invoice?.subtotal} <span className="inline-block w-[13px] h-[13px] align-middle" style={{background:"url('/assets/images/SAR-mini.svg')"}}></span></div>
                                                </div>
                                                <div className="flex flex-nowrap h-[96px] bg-grey-100">
                                                    <div className="w-[50%] text-center">
                                                        <Link to="/ar/marketplace" className="bg-blue text-white text-center rounded-[8px] h-[48px] mt-[24px] min-w-[256px] inline-block leading-[48px] font-[600] text-[18px]" reloadDocument>إضافة طلب جديد</Link>
                                                    </div>
                                                    <div className="w-[50%] text-center">
                                                        <Link to="/ar/orders" className="bg-grey-800 text-white text-center rounded-[8px] h-[48px] mt-[24px] min-w-[256px] inline-block leading-[48px] font-[600] text-[18px]">عرض الطلبات</Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>}
                    
                    {!orderSent && cart && <div className=""> 
                        {Array.isArray(cart) && cart?.length > 0 
                        ? <><div className="flex flex-nowrap gap-x-[25px]">
                            <div className="w-[calc(100%-394px)]">
                                <div className="bg-white rounded-[8px] p-[16px]">
                                    <h2 className="font-[600] text-darkBlue text-[24px] pb-[20px] mb-[20px] border-b-[1px] border-b-grey-200">محتويات سلة الشراء ({cart?.length} منتجات)</h2>
                                    <div className="">
                                        {cartItems?.map((item,index)=>{
                                            return (<div key={`cart-${index}`} className="flex flex-nowrap gap-x-[10px] mt-[25px] bg-grey-50 rounded-[16px] p-[16px]">
                                                <div className="w-[64px] h-[64px] rounded-[8px] !bg-no-repeat !bg-contain cursor-pointer select-none" style={{background: `#fff url(${item?.image}) no-repeat center center / cover`}}></div>
                                                <div className="w-[calc(100%-264px)] font-[600] text-[16px] text-grey-900">{cart[cart?.findIndex(c=>c?.storeProductId === item?.storeProductId)]?.name}</div>
                                                <div className="w-[200px] h-[64px] text-end">
                                                    <div className="text-end text-[18px] text-grey-900"><strong>{cart[cart?.findIndex(c=>c?.storeProductId === item?.storeProductId)]?.price}</strong> <img src="/assets/images/SAR-med.svg" alt="" className="w-[14px] align-middle inline-block select-none" /></div>
                                                    <div className="inline-block w-[140px]">
                                                        <div className="flex flex-nowrap gap-x-[0] mt-[10px] bg-grey-100 w-[140px] rounded-[30px] h-[32px] leading-[32px] select-none">
                                                            <div className="text-end text-[18px] text-grey-900 w-[28px] h-[28px] cursor-pointer" style={{ background: "url('/assets/images/cart-delete.svg') center no-repeat"}} onClick={()=> item?.quantity > 1 ? updateQuantity(item?.storeProductId,item?.quantity-1) : removeFromCart(item?.storeProductId,true)}></div>
                                                            <div className="text-center text-[16px] font-[500] text-black w-[84px]">{item?.quantity}</div>
                                                            <div className="text-end text-[18px] text-grey-900 w-[28px] h-[28px] cursor-pointer" style={{ background: "url('/assets/images/cart-add.svg') center no-repeat"}} onClick={()=>updateQuantity(item?.storeProductId,item?.quantity+1)}></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>)
                                        })}
                                    </div>
                                </div>
                            </div>
                            <div className="w-[394px]">
                                <div className="bg-white rounded-[8px] p-[16px]">

                                    <div className="flex border-b-dotted border-b-[1px] border-b-grey-300 py-[15px]">
                                        <div className="w-[60%]">
                                            <p className="text-grey-900 text-[16px] font-[500]">إجمالي راتب العمالة</p>
                                        </div>
                                        <div className="w-[40%]">
                                            <p className="text-grey-900 text-[16px] font-[500]" dir="ltr">سيتم حسابه</p>
                                        </div>
                                    </div>
                                    <div className="flex pt-[15px]">
                                        <div className="w-[50%]">
                                            <p className="text-grey-900 text-[16px] font-[500]">المجموع</p>
                                        </div>
                                        <div className="w-[50%] text-end">
                                            <p className="text-grey-900 text-[16px] font-[500]">{cart.reduce((total, obj) => total + (obj.price*obj.quantity), 0).toFixed(2)} <img src="/assets/images/SAR-med.svg" alt="" className="w-[11px] align-baseline inline-block select-none" /></p>
                                        </div>
                                    </div>
                                    <div className="flex pt-[15px]">
                                        <div className="w-[75%]">
                                            <p className="text-grey-900 text-[16px] font-[500]">الضريبة</p>
                                        </div>
                                        <div className="w-[25%] text-end">
                                            <p className="text-grey-900 text-[16px] font-[500]">{0} <img src="/assets/images/SAR-med.svg" alt="" className="w-[11px] align-baseline inline-block select-none" /></p>
                                        </div>
                                    </div>
                                    <div className="flex border-b-dotted border-b-[1px] border-b-grey-300 py-[15px]">
                                        <div className="w-[75%]">
                                            <p className="text-grey-900 text-[16px] font-[500]">الخصم</p>
                                        </div>
                                        <div className="w-[25%] text-end">
                                            <p className="text-grey-900 text-[16px] font-[500]">0 <img src="/assets/images/SAR-med.svg" alt="" className="w-[11px] align-baseline inline-block select-none" /></p>
                                        </div>
                                    </div>
                                    <div className="flex pt-[15px]">
                                        <div className="w-[45%]">
                                            <p className="text-grey-900 text-[16px] font-[500]">إجمالي ما سيتم دفعه</p>
                                        </div>
                                        <div className="w-[55%]">
                                            <p className="text-grey-900 text-[18px] font-[700] text-end">{cart.reduce((total, obj) => total + (obj.price*obj.quantity), 0).toFixed(2)} <img src="/assets/images/SAR-med.svg" alt="" className="w-[14px] align-baseline inline-block select-none" /></p>
                                        </div>
                                    </div>

                                    {userData?.business?.credits >= cart.reduce((total, obj) => total + (obj.price*obj.quantity), 0)
                                    ? <div className="text-success text-[14px] text-center font-[500] leading-[21px] my-[15px]">
                                    رصيد المحفظة كافي لإتمام الطلب
                                    </div>
                                    : <div className="flex flex-nowrap gap-x-[5px]">
                                        <div className="w-[calc(100%-95px)] text-danger text-[14px] font-[500] leading-[21px] my-[15px]">
                                        رصيد المحفظة غير كافي لإتمام الطلب
                                        </div>
                                        <div className="w-[90px] text-end pt-[10px]">
                                            <Link className="inline-block bg-blue text-white p-[4px_8px] text-[14px] rounded-[8px] whitespace-nowrap text-center" to="/ar/wallet" target="_blank" rel="noopener noreferrer">شحن المحفظة</Link>
                                        </div>
                                    </div>}

                                </div>
                            </div>
                            
                            
                        </div>
                        <div className="text-end">
                                <div className={`w-[194px] h-[48px] leading-[48px] inline-block text-center mt-[24px] bg-grey-800 text-white font-[600] text-[18px] rounded-[10px] cursor-pointer select-none`} onClick={()=>handleClickSubmitRequest()}>اتمام الطلب</div>
                            </div>
                        </>
                        : <div className="pt-[80px] text-center">
                            <div className="inline-block w-[188px] h-[188px] !bg-contain !bg-center" style={{background: "url('/assets/images/cart.svg')"}}></div>
                            <div className="w-full text-center text-grey-900 text-[24px] font-[500] mb-[25px]">لاتوجد منتجات في السلة حتي الأن</div>
                        </div>}
                    </div>}
                    
                </MainContent>
            </PageMain>

                { noCreditsModal && <ModalContainer heading="رصيد المحفظة غير كافي" handleCloseModal={handleCloseModal}>
                    <div className="mb-[25px]">
                      <p className="text-[16px] text-grey-900">رصيد المحفظة الحالي غير كافي لإتمام الطلب من فضلك قم بشحن الرصيد بقيمة {cart.reduce((total, obj) => total + (obj.price*obj.quantity), 0) - userData?.business?.credits} ريال لتتمكن من تسجيل طلبك</p>
                    </div>
                    <div className="text-end">
                      <div className="text-grey-400 text-[18px] font-[600] inline-block cursor-pointer select-none me-[50px]" onClick={handleCloseModal}>إلغاء</div>
                      <Link className="inline-block bg-grey-800 text-white px-[8px] text-center text-[18px] font-[600] h-[48px] leading-[48px] w-[300px] rounded-[8px]" to="/ar/wallet" target="_blank" rel="noopener noreferrer" onClick={handleCloseModal}>شحن المحفظة</Link>
                    </div>
                </ModalContainer> }

                 { showUnitLimitExceeded && <ModalContainer heading="تنبيه حد المصاريف" hideX={true}>
                    <div className="h-[1px] w-full bg-grey-100 my-[24px]"></div>
                    <p className="text-[18px] text-grey-900 leading-[24px] font-[400] mb-[24px]">تم الوصول للحد الأقصى من حد المصاريف المسموح، يرجى مراجعة حد المصاريف.</p>
                    <p className="text-[18px] text-grey-900 font-[600]">هل انت متاكد من تنفيذ هذا الطلب ؟</p>
                    <div className="h-[1px] w-full bg-grey-100 my-[24px]"></div>
                    <div className="text-end">
                        <NormalButton label={'اغلاق'} onClick={handleCloseModalLimitExceeded} color={'!bg-grey-800 !w-[228px] !text-center'} />
                        <NormalButton label={'تنفيذ الطلب'} onClick={handleClickSubmitRequestAction} color={'!bg-white !w-[228px] !text-grey-600 !border-[1px] !border-grey-600 !rounded-[8px] !ms-[24px]'} />
                    </div>
                </ModalContainer> }

            {isLoading && <Loading showLoading={true} />}
            <Toast toast={toast} setToast={setToast} />
    </div>
  );
};

export default CartPage;
